import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import LocationSection from './components/LocationSection';
import ServicesSection from '../../home/components/ServicesSection';
import BenefitsSection from '../../home/components/BenefitsSection';
import TintShadesSection from '../../home/components/TintShadesSection';
import TestimonialsSection from '../../home/components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from '../../home/components/CTASection';
import { useSEO, generateLocalBusinessSchema, generateWebPageSchema } from '../../../utils/seo';
import { useEffect } from 'react';

export default function TowsonPage() {
  // Apply localized SEO metadata with geo-tags
  useSEO({
    title: 'Towson Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint',
    description:
      'Professional window tinting services in Towson, Maryland. Expert ceramic tint installation, mobile service, commercial tinting, vehicle decals, and headlight tinting. Serving Towson, Lutherville, Timonium. Lifetime warranty. Call (443) 800-0348.',
    keywords:
      'window tinting Towson, ceramic tint Towson MD, mobile tinting Towson, commercial tinting Towson, vehicle decals Towson',
    canonical: '/locations/towson',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          ...generateLocalBusinessSchema(),
          '@type': 'AutoRepair',
          name: 'U.B.K Window Tint - Towson',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '',
            addressLocality: 'Towson',
            addressRegion: 'MD',
            postalCode: '21204',
            addressCountry: 'US',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: '39.4015',
            longitude: '-76.6019',
          },
          areaServed: {
            '@type': 'City',
            name: 'Towson',
            '@id': 'https://en.wikipedia.org/wiki/Towson,_Maryland',
          },
        },
        generateWebPageSchema(
          'Towson Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint',
          'Professional window tinting services in Towson, Maryland with lifetime warranty and same-day service.',
          '/locations/towson'
        ),
      ],
    },
  });

  useEffect(() => {
    // Add geo meta tags for local SEO
    const geoTags = [
      { name: 'geo.region', content: 'US-MD' },
      { name: 'geo.placename', content: 'Towson' },
      { name: 'geo.position', content: '39.4015;-76.6019' },
      { name: 'ICBM', content: '39.4015, -76.6019' },
    ];

    geoTags.forEach(tag => {
      let meta = document.querySelector(`meta[name="${tag.name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', tag.name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <header>
        <h1 className="sr-only">
          Towson Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint
        </h1>
      </header>
      <main>
        <HeroSection />
        <LocationSection />
        <ServicesSection />
        <BenefitsSection />
        <TintShadesSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
